<template>
  <div class="news-detail-container">
    <!-- 添加面包屑导航 -->
    <nav class="breadcrumb" aria-label="面包屑导航">
      <router-link to="/">首页</router-link> &gt;
      <router-link to="/about/hxnews">新闻中心</router-link> &gt;
      <span>新闻详情</span>
    </nav>

    <article v-if="currentNews" class="news-article">
      <header class="article-header">
        <h1 class="news-detail-title">{{ currentNews.title }}</h1>
        <div class="article-meta">
          <time class="news-detail-date" :datetime="formatDate(currentNews.date)">
            {{ currentNews.date }}
          </time>
          <span class="article-category">导购激励资讯</span>
        </div>
      </header>

      <div class="article-content" v-html="currentNews.content"></div>

      <!-- 添加相关新闻推荐 -->
      <!-- <aside class="related-news" v-if="relatedNews.length">
        <h3>相关推荐</h3>
        <div class="related-list">
          <div v-for="news in relatedNews" :key="news.id" class="related-item">
            <router-link :to="`/about/news/${news.id}`" class="related-link">
              {{ news.title }}
            </router-link>
          </div>
        </div>
      </aside> -->

      <footer class="article-footer">
        <button class="btn btn-outline-primary back-button" @click="goBack">
          返回新闻列表
        </button>
      </footer>
    </article>

    <div v-else class="news-not-found">
      <p>新闻不存在或已被删除</p>
      <button class="btn btn-outline-primary" @click="goBack">返回新闻列表</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsDetail',
  data() {
    return {
      currentNews: null,
      // 模拟新闻数据 - 优化内容和关键词
      newsData: [
        {
          id: 1,
          date: '2019-12',
          title: '禾销平台正式上线：重新定义导购激励政策落地方式',
          summary: '禾销智能导购激励平台成功发布，为零售品牌提供导购激励政策定制、费用核销与动销数据一体化解决方案。',
          content: `
            <p>2019年12月，禾苗（武汉）信息技术有限公司正式发布<strong>"禾销"智能导购激励平台</strong>，这标志着公司在<strong>零售数字化</strong>领域迈出了重要一步。</p>
            
            <h2>解决导购激励核心痛点</h2>
            <p>该平台专注于解决<strong>母婴、美妆</strong>等行业品牌方在<strong>导购激励政策</strong>落地过程中面临的核心痛点。通过智能化的<strong>导购激励政策</strong>配置引擎，帮助品牌方灵活制定阶梯奖励、红包激励等多种方案。</p>
            
            <h2>创新功能助力效率提升</h2>
            <p>平台创新性地推出<strong>"我要核销"</strong>功能，实现费用线上化、透明化管理，大幅提升<strong>核销效率</strong>。同时，通过实时<strong>动销数据</strong>看板，让品牌方清晰掌握激励效果。</p>
            
            <h2>为零售行业赋能</h2>
            <p>"我们深刻理解品牌方在<strong>导购激励</strong>管理中的挑战，"禾苗创始人表示，"<strong>禾销平台</strong>的推出，正是为了帮助客户实现<strong>导购激励政策</strong>的数字化、标准化落地。"</p>
            
            <p>如果您正在寻找专业的<strong>导购激励工具</strong>，<a href="tel:15392850129" title="联系禾销">欢迎了解禾销平台的更多功能</a>。</p>
          `
        },
        {
          id: 2,
          date: '2023-05',
          title: '禾销导购激励平台服务门店突破40000家，导购员超10万',
          summary: '禾销平台业务快速增长，已服务全国40000+母婴、美妆门店，覆盖10万+零售导购员，成为行业领先的<strong>导购激励政策</strong>落地工具。',
          content: `
            <p>禾苗今日发布最新业务数据，截至2023年5月，其旗下<strong>禾销导购激励平台</strong>已成功服务全国超过40000家<strong>母婴、美妆</strong>门店，覆盖导购员数量突破10万人。这一数据标志着<strong>禾销平台</strong>已成为行业领先的<strong>导购激励政策</strong>落地工具。</p>
            
            <h2>平台价值获得市场认可</h2>
            <p><strong>禾销平台</strong>自上线以来，凭借其强大的<strong>导购激励政策</strong>配置能力、高效的<strong>费用核销</strong>流程和精准的<strong>动销数据</strong>分析，赢得了众多知名品牌和零售商的青睐。平台不仅帮助客户实现了<strong>导购激励政策</strong>的精准落地，还通过大数据分析，为客户提供了更科学的决策依据。</p>
            
            <h2>未来发展规划</h2>
            <p>禾苗创始人表示，平台的快速发展离不开客户的信任和支持。"未来，我们将继续深化与各行业客户的合作，不断优化<strong>禾销平台</strong>的产品体验，为<strong>零售数字化</strong>转型贡献更多力量。"</p>
            
            <p>据了解，禾苗正在研发<strong>禾销平台</strong>的新一代产品，将引入更多AI技术，进一步提升<strong>导购激励</strong>的智能化水平和效果。</p>
          `
        }
      ]
    }
  },
  created() {
    this.fetchNewsDetail()
  },
  computed: {
    relatedNews() {
      if (!this.currentNews) return []
      const currentId = this.currentNews.id
      return this.newsData
        .filter(news => news.id !== currentId)
        .slice(0, 3) // 只显示3条相关新闻
    }
  },
  methods: {
    fetchNewsDetail() {
      const newsId = parseInt(this.$route.params.id)
      this.currentNews = this.newsData.find(news => news.id === newsId)
      
      // 如果需要从API获取数据，可以使用以下代码
      // import api from '@/utils/api'
      // api.getNewsDetail(newsId).then(res => {
      //   this.currentNews = res.data
      // }).catch(err => {
      //   console.error('获取新闻详情失败:', err)
      // })
    },
    goBack() {
      this.$router.push('/about/hxnews')
    },
    formatDate(date) {
      // 格式化日期为YYYY-MM-DD
      return date + '-01' // 假设都是月初
    }
  }
}
</script>

<style scoped>
.news-detail-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* 面包屑导航样式 */
.breadcrumb {
  margin-bottom: 20px;
  font-size: 14px;
}

.breadcrumb a {
  color: #007bff;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

/* 新闻文章样式 */
.news-article {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 文章头部样式 */
.article-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.news-detail-title {
  color: #333;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.4;
}

.article-meta {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.news-detail-date {
  color: #666;
  font-size: 14px;
}

.article-category {
  background: #007bff;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

/* 文章内容样式 */
.article-content {
  color: #333;
  line-height: 2;
  font-size: 16px;
  margin-bottom: 30px;
  letter-spacing: 0.05em;
}

/* 优化段落样式 */
.article-content p {
  margin-bottom: 24px;
  text-align: justify;
  text-indent: 2em; /* 首行缩进2个字符 */
  line-height: 1.8;
}

/* 增强标题层级样式 */
.article-content h2 {
  color: #2c3e50;
  margin: 35px 0 20px;
  padding-bottom: 10px;
  font-size: 1.4em;
  font-weight: 600;
  border-bottom: 2px solid #eaeaea;
  position: relative;
}

.article-content h2::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  background-color: #007bff;
}

.article-content h3 {
  color: #34495e;
  margin: 30px 0 15px;
  font-size: 1.2em;
  font-weight: 600;
}

/* 使用深度选择器确保样式应用到v-html内容 */
.article-content >>> strong {
  color: #007bff;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 0 2px;
}

/* 兼容不同的Vue版本 */
.article-content /deep/ strong {
  color: #007bff;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 0 2px;
}

.article-content ::v-deep strong {
  color: #007bff;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 0 2px;
}

/* 优化链接样式 */
.article-content a {
  color: #007bff;
  text-decoration: none;
  border-bottom: 1px dotted #007bff;
  padding-bottom: 1px;
  transition: all 0.3s ease;
}

.article-content a:hover {
  color: #0056b3;
  text-decoration: none;
  border-bottom-color: #0056b3;
  border-bottom-style: solid;
}

/* 添加列表样式 */
.article-content ul,
.article-content ol {
  margin: 20px 0 20px 2em;
  padding-left: 1em;
}

.article-content li {
  margin-bottom: 8px;
  line-height: 1.6;
}

/* 添加引用样式 */
.article-content blockquote {
  margin: 25px 0;
  padding: 15px 20px 15px 45px;
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  font-style: italic;
  position: relative;
}

.article-content blockquote::before {
  content: "\201C"; /* 左双引号 */
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 3em;
  color: #e0e0e0;
  font-family: serif;
}

/* 添加代码样式 */
.article-content code {
  background-color: #f6f8fa;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.9em;
  color: #e83e8c;
}

/* 相关新闻样式 */
.related-news {
  margin-top: 40px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.related-news h3 {
  margin-bottom: 15px;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.related-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.related-item {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.related-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.related-link {
  color: #333;
  text-decoration: none;
  display: block;
  padding: 8px 0;
  transition: color 0.3s ease;
  cursor: pointer;
  z-index: 1;
  position: relative;
}

.related-link:hover {
  color: #007bff;
  text-decoration: underline;
}

/* 文章底部样式 */
.article-footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

/* 未找到页面样式 */
.news-not-found {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.back-button {
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .news-article {
    padding: 20px;
  }
  
  .news-detail-title {
    font-size: 24px;
  }
  
  .article-content {
    font-size: 14px;
  }
  
  .article-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>